var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#3063d5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.222 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(6.222 1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.692,5l-3.556,5.807L22.577,5H13.222l7.1,11.595a10.854,10.854,0,1,0,11.627,0L39.055,5ZM15.947,6.527h5.775l3.517,5.745-1.82,2.971a10.624,10.624,0,0,0-1.752.623ZM35.3,25.753a9.163,9.163,0,1,1-9.164-9.163A9.173,9.173,0,0,1,35.3,25.753Zm-4.693-9.887a10.777,10.777,0,0,0-4.471-.967c-.247,0-.491.011-.735.027l5.146-8.4h5.781Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.309,50.667A7.267,7.267,0,1,0,36.575,43.4,7.274,7.274,0,0,0,29.309,50.667Zm13.008,0a5.741,5.741,0,1,1-5.741-5.741A5.748,5.748,0,0,1,42.317,50.667Z",
    transform: "translate(-10.437 -24.914)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.eeed2b1026a0b6e21f1a934363f9be51.svg";
export { ForwardRef as ReactComponent };